import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";
import { sanitizeConfigOptions } from "@labxchange/util-sanitization";

/**
 * OptionFeedback:
 *  - Feedback message for a particular Option
 */
export function OptionFeedback(props) {
  if (props.visible) {
    return (
      <div className={`${style.feedback} ${props.className}`}>
        <FormattedMessage
          string={"<b>{isCorrect}</b>: {feedbackText}"}
          sanitizeConfig={sanitizeConfigOptions.LightInlineText}
          description=""
          values={{
            isCorrect: props.isCorrect
              ? FormattedMessage({
                  string: "Correct",
                })
              : FormattedMessage({
                  string: "Not quite",
                }),
            feedbackText:
              props.feedbackText !== ""
                ? FormattedMessage({
                    string: props.feedbackText,
                    sanitizeConfig: sanitizeConfigOptions.LightInlineText,
                  })
                : "",
          }}
        />
      </div>
    );
  } else return null;
}

OptionFeedback.propTypes = {
  /**
   * Boolean specifying if feedback is visible
   */
  visible: PropTypes.bool.isRequired,
  /**
   * text to be displayed as feedback
   */
  feedbackText: PropTypes.string.isRequired,
  /**
   * className to be set for feedback element
   */
  className: PropTypes.string,
};

OptionFeedback.defaultProps = {
  visible: false,
  feedbackText: "",
};
